import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { TextField } from 'redux-form-material-ui';
import RaisedButton from 'material-ui/RaisedButton';
import _ from 'lodash';

class UnitForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
  }
  static validate = (values) => {
    const errors = {};
    const requiredFields = ['name',];

    requiredFields.forEach((item) => {
      if (!values[item]) {
        errors[item] = 'Required';
      }
    });
    
    return errors;
  }

  renderTextField = props => {
    const { initValue, ...newProps } = props;
    return (<TextField hintText={props.label} floatingLabelText={props.label} errorText={props.touched && props.error} {...newProps} value={initValue} />);
  };


  render() {
    const { handleSubmit, submitting } = this.props;
    
    const buttonText = (submitting) ? 'Saving...' : 'Add Unit';
    return (
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col s12 m6">
            <Field name="name" type="text" component={this.renderTextField} floatingLabelText="Unit Identifier" fullWidth />
          </div>
        </div>
        <div className="row">
          <div className="col s12 m8"></div>
          <div className="col s12 m4">
            <RaisedButton onClick={handleSubmit} fullWidth primary style={{color:'#fff'}}>{buttonText}</RaisedButton>
          </div>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'newUnitForm',
  validate: UnitForm.validate
})(UnitForm);





// WEBPACK FOOTER //
// ./src/components/Fleet/Units/Add.js